import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Customize_Css/Pagination.css';
import '../Customize_Css/ViewVendor.css';
import '../Customize_Css/Banners.css';
import { Dropdown, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaTrashAlt, FaFileExport, FaEdit, FaSearch, FaEye, FaTicketAlt } from 'react-icons/fa';
import axios from 'axios';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';

const ViewPromoCode = () => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const epicxTenantId = localStorage.getItem('epicxTenantId');
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedItems, setSelectedItems] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedPromo, setSelectedPromo] = useState(null);
   const AuthorizationToken = localStorage.getItem('token');

    const fetchPromoCodes = async () => {
        if (!epicxTenantId) {
            console.error('Tenant ID is not provided');
            return;
        }
        try {
            const response = await axios.get(`${BASE_URL}/promoCode/api/promoCode/${epicxTenantId}`,
                {
                    headers: {
                      Authorization: `Bearer ${AuthorizationToken}`,
                    },
                  }
            );
            let promoCodes = [];
            if (Array.isArray(response.data)) {
                promoCodes = response.data;
            } else if (response.data.promoCodes && Array.isArray(response.data.promoCodes)) {
                promoCodes = response.data.promoCodes;
            } else {
                console.error('API response structure does not match expected array format:', response.data);
                promoCodes = [];
            }
            setData(promoCodes);
            setOriginalData(promoCodes);
        } catch (error) {
            console.error('Error fetching promo codes data:', error);
        }
    };

    useEffect(() => {
        fetchPromoCodes();
    }, [epicxTenantId]);

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
        setData((prevData) => {
            const sortedData = [...prevData].sort((a, b) => {
                if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
                if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
                return 0;
            });
            return sortedData;
        });
    };

    const handleSearch = (value) => {
        setSearchTerm(value);
        const lowerCaseValue = value.toLowerCase().trim();
        if (lowerCaseValue === '') {
            setData(originalData);
        } else {
            const filteredData = originalData.filter((item) =>
                Object.values(item).some((val) =>
                    val && val.toString().toLowerCase().includes(lowerCaseValue)
                )
            );
            setData(filteredData);
        }
        setCurrentPage(1);
    };

    const handleSelectAll = () => {
        if (selectedItems.length === data.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems(data.map(item => item._id));
        }
    };

    const handleSelectItem = (_id) => {
        if (selectedItems.includes(_id)) {
            setSelectedItems(selectedItems.filter(item => item !== _id));
        } else {
            setSelectedItems([...selectedItems, _id]);
        }
    };

    const handleEdit = () => {
        if (selectedItems.length === 1) {
            const [selectedId] = selectedItems;
            navigate(`/updatePromoCode/${selectedId}`);
        } else {
            toast.error("Please select exactly one promo code to edit");
        }
    };

    const handleDelete = async () => {
        if (selectedItems.length === 0) {
            toast.error('No items selected for deletion');
            return;
        }
        const confirmDelete = window.confirm('Are you sure you want to delete the selected items?');
        if (!confirmDelete) {
            toast.info('Deletion canceled');
            return;
        }
        try {
            const deleteRequests = selectedItems.map(id =>
                axios.put(`${BASE_URL}/promoCode/api/promoCode/${epicxTenantId}/delete/${id}`,
                    {}, 
                    {
                      headers: {
                        Authorization: `Bearer ${AuthorizationToken}`,
                      },
                    }
                )
            );
            await Promise.all(deleteRequests);
            await fetchPromoCodes();
            setSelectedItems([]);
            toast.success('Items deleted successfully');
        } catch (error) {
            console.error('Error deleting promo codes:', error);
            toast.error('Error deleting items');
        }
    };

    const handleExport = () => {
        const dataToExport = selectedItems.length > 0
            ? data.filter(item => selectedItems.includes(item._id))
            : data;
        const exportData = dataToExport.map(item => ({
            promoCodeName: item.promoCodeName,
            promoCodeType: item.promoCodeType,
            promoCodeValue: item.promoCodeValue,
            promoCodeUsageLimit: item.promoCodeUsageLimit,
            minimumOrderValue: item.minimumOrderValue,
            maximumDiscountValue: item.maximumDiscountValue,
            startDate: item.startDate,
            endDate: item.endDate,
            ActiveorDeactivatePromoCode: item.isActive ? 'Active' : 'Deactivate',
            promoCodeDescription: item.promoCodeDescription,
            createdAt: item.createdAt,
            applicableProducts: item.applicableProducts?.map(p => p.name).join(', '),
            categories: item.categories?.map(c => c.name).join(', '),
            eligibleUsers: item.selectedUsers?.map(u => u.name).join(', '),
        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "PromoCode");
        XLSX.writeFile(wb, 'promocode_data.xlsx');
    };

    const handleViewMore = (promo) => {
        setSelectedPromo(promo);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedPromo(null);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = Array.isArray(data) ? data.slice(indexOfFirstItem, indexOfLastItem) : [];
    const totalPages = Math.ceil(data.length / itemsPerPage);

    return (
        <>
            <Sidebar />
            <div className="vendors-page">
                <div>
                    <header className="vendors-hero">
                        <div>
                            <p className="vendors-kicker">Sales</p>
                            <h1>Promo Codes List</h1>
                            <p>Browse, find, and manage promo codes.</p>
                        </div>
                        <button className="vendors-primary-btn" onClick={() => navigate(`/addpromocode/${epicxTenantId}`)}>
                            <FaPlus /> Add Promo Code
                        </button>
                    </header>
                    <section className="vendors-toolbar" aria-label="Promo code search and actions">
                        <div className="vendors-search">
                            <FaSearch aria-hidden="true" />
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search promo codes..."
                                aria-label="Search promo codes"
                                value={searchTerm}
                                onChange={(e) => handleSearch(e.target.value)}
                            />
                        </div>
                        <Dropdown>
                            <Dropdown.Toggle className="vendors-action-btn">Action</Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={handleDelete} disabled={selectedItems.length === 0}>
                                    <FaTrashAlt className="me-2" /> Delete
                                </Dropdown.Item>
                                <Dropdown.Item onClick={handleEdit} disabled={selectedItems.length !== 1}>
                                    <FaEdit className="me-2" /> Edit
                                </Dropdown.Item>
                                <Dropdown.Item onClick={handleExport}>
                                    <FaFileExport className="me-2" /> Export
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </section>
                    <div className="vendors-card">
                        <div className="vendors-card-head">
                            <div>
                                <h2>All Promo Codes</h2>
                                <p>Select a code to edit, delete, or view full details.</p>
                            </div>
                            <span className="vendors-count">
                                <FaTicketAlt aria-hidden="true" />
                                {data.length} {data.length === 1 ? 'code' : 'codes'}
                            </span>
                        </div>
                        <div className="vendors-card-body">
                            <div className="vendors-table-wrap no-scroll">
                                <table className="vendors-table vendors-table-plain">
                                    <thead>
                                        <tr>
                                            <th className="vendors-check-cell">
                                                <input className="vendors-checkbox" type="checkbox" aria-label="Select all promo codes" checked={selectedItems.length === data.length && data.length > 0} onChange={handleSelectAll} />
                                            </th>
                                            {[
                                                ['promoCodeName', 'Promo Code Name'],
                                                ['promoCodeType', 'Promo Code Type'],
                                                ['promoCodeValue', 'Promo Code Value'],
                                                ['startDate', 'Start Date'],
                                                ['endDate', 'End Date'],
                                            ].map(([key, label]) => (
                                                <th key={key} onClick={() => handleSort(key)}>
                                                    {label}{sortConfig.key === key ? (sortConfig.direction === 'asc' ? ' ▲' : ' ▼') : ''}
                                                </th>
                                            ))}
                                            <th className="vendors-action-cell">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentData.length > 0 ? currentData.map((item) => (
                                            <tr key={item._id} className={selectedItems.includes(item._id) ? 'is-selected' : ''}>
                                                <td className="vendors-check-cell">
                                                    <input className="vendors-checkbox" type="checkbox" aria-label={`Select ${item.promoCodeName}`} checked={selectedItems.includes(item._id)} onChange={() => handleSelectItem(item._id)} />
                                                </td>
                                                <td><span className="vendor-name">{item.promoCodeName}</span></td>
                                                <td><span className="banner-chip">{item.promoCodeType}</span></td>
                                                <td>{item.promoCodeValue}</td>
                                                <td>{new Date(item.startDate).toLocaleDateString()}</td>
                                                <td>{new Date(item.endDate).toLocaleDateString()}</td>
                                                <td className="vendors-action-cell">
                                                    <button type="button" className="vendors-view-btn" onClick={() => handleViewMore(item)}>
                                                        <FaEye aria-hidden="true" /> View More
                                                    </button>
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan="7">
                                                    <div className="vendors-empty">
                                                        <span><FaTicketAlt aria-hidden="true" /></span>
                                                        <h3>No promo codes found</h3>
                                                        <p>Try another search or add a new promo code.</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="vendors-card-footer">
                            <span className="vendors-page-summary">
                                {data.length > 0 ? `Showing ${indexOfFirstItem + 1}–${Math.min(indexOfLastItem, data.length)} of ${data.length}` : 'Showing 0 promo codes'}
                            </span>
                            <div className="vendors-pagination">
                                <nav>
                                    <ul className="pagination mb-0" aria-label="Promo codes pagination">
                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button className="page-link btn-sm" onClick={() => setCurrentPage(1)} aria-label="First page">&laquo;</button>
                                        </li>
                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button className="page-link btn-sm" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} aria-label="Previous page">&lt;</button>
                                        </li>
                                        <li className="page-item active">
                                            <button className="page-link btn-sm" aria-current="page">{currentPage}</button>
                                        </li>
                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                            <button className="page-link btn-sm" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} aria-label="Next page">&gt;</button>
                                        </li>
                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                            <button className="page-link btn-sm" onClick={() => setCurrentPage(totalPages)} aria-label="Last page">&raquo;</button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="vendors-footer">
                    <Footer />
                </div>
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={true}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    style={{ zIndex: 9999 }}
                />
            </div>

            <Modal show={showModal} onHide={handleCloseModal} size="lg" centered dialogClassName="vendor-details-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Promo Code Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedPromo && (
                        <div className="vendor-details-content">
                            <div className="vendor-details-title">
                                <span><FaTicketAlt aria-hidden="true" /></span>
                                <div>
                                    <small>Promo code</small>
                                    <h3>{selectedPromo.promoCodeName}</h3>
                                    <p>{selectedPromo.isActive ? 'Active' : 'Inactive'}</p>
                                </div>
                            </div>
                            <div className="vendor-details-grid">
                                <div><span>Promo Code Name</span><strong>{selectedPromo.promoCodeName}</strong></div>
                                <div><span>Type</span><strong>{selectedPromo.promoCodeType}</strong></div>
                                <div><span>Value</span><strong>{selectedPromo.promoCodeValue}</strong></div>
                                <div><span>Promo Type</span><strong>{selectedPromo.promoType}</strong></div>
                                <div className="details-wide"><span>Description</span><strong>{selectedPromo.promoCodeDescription}</strong></div>
                                <div><span>Applicable Users</span><strong>{selectedPromo.applicableUsers}</strong></div>
                                <div><span>Status</span><strong>{selectedPromo.isActive ? 'Active' : 'Inactive'}</strong></div>
                                <div><span>Delivery Charge Waiver</span><strong>{selectedPromo.deliveryChargeWaiver ? 'Yes' : 'No'}</strong></div>
                                <div><span>Cashback Offer</span><strong>{selectedPromo.cashbackOffer ? 'Yes' : 'No'}</strong></div>
                                <div><span>Auto Applied</span><strong>{selectedPromo.appliedAutomatically ? 'Yes' : 'No'}</strong></div>
                            </div>
                            <section className="vendor-details-section">
                                <h4>Applicable Products</h4>
                                {selectedPromo.applicableProducts?.length ? (
                                    <ul>{selectedPromo.applicableProducts.map(product => <li key={product.id}>{product.name}</li>)}</ul>
                                ) : <p className="vendor-details-empty">No products listed.</p>}
                            </section>
                            <section className="vendor-details-section">
                                <h4>Applicable Categories</h4>
                                {selectedPromo.categories?.length ? (
                                    <ul>{selectedPromo.categories.map(category => <li key={category.id}>{category.name}</li>)}</ul>
                                ) : <p className="vendor-details-empty">No categories listed.</p>}
                            </section>
                            <section className="vendor-details-section">
                                <h4>Applicable Product Vendors</h4>
                                {selectedPromo.selectedUsers?.length ? (
                                    <ul>{selectedPromo.selectedUsers.map(user => <li key={user.id}>{user.name}</li>)}</ul>
                                ) : <p className="vendor-details-empty">No vendors listed.</p>}
                            </section>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="vendors-modal-close" onClick={handleCloseModal}>Close</button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ViewPromoCode;